import { useFormik } from "formik";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { CiBank } from "react-icons/ci";
import { generateCustomStyles } from "../Helper/CustomStyleError";
import PostApiCall from "../Api/Api";
import Select from "react-select";
import { useEffect, useState } from "react";
import { SomethingWrong } from "../Helper/ErrorMessages";
import Notiflix, { Report } from "notiflix";
import { toast } from "react-toastify";
import { delay } from "../Helper/ToastDelay";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { ProfileAction } from "../Store/Actions/ProfileAction";
import CommonModal from "./CommonModal";
import { User } from "react-feather";
import axios from "axios";

const BankDetails = () => {
  // Validation Schema
  const validationSchema = Yup.object({
    AuditorName: Yup.string().required("Full Name is required"),
    BankName: Yup.string().required("Bank Name is required"),
    BankIfscCode: Yup.string()
      .required("IFSC Code is required")
      .matches(
        /^[A-Z]{4}0[A-Z0-9]{6}$/,
        "Enter a valid IFSC Code (e.g., ABCD0123456)"
      ),
    AccountNumber: Yup.string()
      .required("Account Number is required")
      .matches(/^\d+$/, "Account Number should contain only numbers")
      .min(9, "Account Number should be at least 9 digits")
      .max(18, "Account Number should not exceed 18 digits"),
    UpiId: Yup.string()
      .notRequired()
      .matches(
        /^[\w.-]+@[\w.-]+$/,
        "Enter a valid UPI ID (e.g., example@bank)"
      ),

    AuditorCity: Yup.object().shape({
      value: Yup.string().required("City is required"),
    }),
    AuditorState: Yup.object().shape({
      value: Yup.string().required("State is required"),
    }),
  });
  const [isEditable, setIsEditable] = useState(true);

  const { user } = useSelector((state) => state.profile);

  const [addBankModal, setAddBankModal] = useState(false);
  const [type, settype] = useState(
    user?.fld_accountno === "" || user?.fld_accountno === null
      ? "Add"
      : "Update"
  );

  const dispatch = useDispatch();
  const [allState, setAllState] = useState([]);
  const [allCity, setAllCity] = useState([]);
  const formik = useFormik({
    initialValues: {
      AuditorName: user?.fld_holdername,
      BankName: user?.fld_bankname,
      BankIfscCode: user?.fld_ifsccode,
      AccountNumber: user?.fld_accountno,
      UpiId: user?.fld_upi,
      AuditorState: user?.fld_bankstate
        ? { label: user.fld_bankstate, value: user.fld_bankstate }
        : "",
      AuditorCity: user?.fld_bankcity
        ? { label: user.fld_bankcity, value: user.fld_bankcity }
        : "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        Notiflix.Loading.standard();

        // Construct the payload
        const payload = {
          userid: user?.fld_id[0],
          holdername: values?.AuditorName,
          bankname: values?.BankName,
          ifsccode: values?.BankIfscCode,
          accountno: values?.AccountNumber,
          upi: values?.UpiId || "",
          bankstate: values?.AuditorState?.label,
          bankcity: values?.AuditorCity?.label,
        };

        // Determine the API URL based on account status
        const url =
          user?.fld_accountno === ""
            ? "AddJobAuditorBank"
            : "UpdateJobAuditorBank";

        // Make the API request
        const res = await PostApiCall.postRequest(payload, url);

        // Ensure `res` contains a JSON-parsable body
        const responseData = await res.json();

        if (res.status === 200 || res.status === 201) {
          // Stop the loading animation
          Notiflix.Loading.remove();

          // Dispatch the profile details update
          dispatch(ProfileAction.GetSeekerDetails());

          // Show success notification
          Report.success(`${responseData.data}`, "", "ok");

          // Close the modal
          setAddBankModal(false);
        } else {
          // Handle non-successful responses
          Notiflix.Loading.remove();
          toast.error(SomethingWrong, {
            autoClose: delay,
            toastId: 1,
          });
        }
      } catch (error) {
        // Handle errors
        console.error(error);

        Notiflix.Loading.remove();

        toast.error(SomethingWrong, {
          autoClose: delay,
          toastId: 1,
        });
      }
    },
  });
  useEffect(() => {
    if (user) {
      formik.setValues({
        AuditorName: user?.fld_holdername,
        BankName: user?.fld_bankname,
        BankIfscCode: user?.fld_ifsccode,
        AccountNumber: user?.fld_accountno,
        UpiId: user?.fld_upi,
        AuditorState: user?.fld_bankstate
          ? { label: user.fld_bankstate, value: user.fld_bankstate }
          : "",
        AuditorCity: user?.fld_bankcity
          ? { label: user.fld_bankcity, value: user.fld_bankcity }
          : "",
      });
    }
    settype(
      user?.fld_accountno === "" || user?.fld_accountno === null
        ? "Add"
        : "Update"
    );
  }, [user]);
  const submitHandler = async () => {
    formik.handleSubmit();
  };

  useEffect(() => {
    const getState = () => {
      PostApiCall.postRequest({ countryid: 101 }, "GetState").then(
        (resultdes) =>
          resultdes.json().then((obj) => {
            setAllState(obj?.data);
            // formik.setFieldValue("state", obj?.data[0]);
            // Notiflix.Loading.remove()
          })
      );
    };
    getState();
  }, []);
  useEffect(() => {
    const getCity = () => {
      const filterCity = allState?.find(
        (i) => i?.label == formik.values?.AuditorState?.label
      );
      PostApiCall.postRequest({ stateid: filterCity?.value }, "GetCity").then(
        (resultdes) =>
          resultdes.json().then((obj) => {
            const cities = obj?.data || [];
            setAllCity(cities);

            if (cities.length < 0) {
              formik.setFieldValue("AuditorCity", {
                value: "none",
                label: "None",
              });
            }
            // Notiflix.Loading.remove()
          })
      );
    };
    getCity();
  }, [formik.values.AuditorState, allState]);

  const FormGroupDisplay = ({ label, value }) => {
    return (
      <div className="form-group">
        <label> {label}</label>
        <p className="text-dark" style={{ textTransform: "capitalize" }}>
          {value}
        </p>
      </div>
    );
  };
  const findBankHandler = async () => {
    try {
      // Make the API request
      const { data } = await axios.get(`https://ifsc.razorpay.com/${formik.values?.BankIfscCode}`);
  
      formik.setFieldValue("BankName", data.BANK);
      formik.setFieldValue("AuditorState", {
        label: data.STATE,
        value: data.STATE,
      });
      formik.setFieldValue("AuditorCity", {
        label: data.CITY,
        value: data.CITY,
      });
    } catch (error) {
      console.log(error.response.data);
      toast.error(error.response.data);
    }
  };
  return (
    <div>
      <Card id="jobCard " className="border-0">
        <p className="d-flex my-3 ml-4 ">
          <CiBank size={30} className="mr-1" color="black" />{" "}
          <h6 className="headingStyle"> Account Details</h6>
        </p>

        <CardBody>
          {user?.fld_accountno === "" || user?.fld_accountno === null ? (
            <div className="d-flex justify-content-end">
              <button
                style={{ textTransform: "capitalize" }}
                onClick={() => setAddBankModal(true)}
                className="btns"
              >
                Add Details
              </button>
            </div>
          ) : (
            <>
              <Row>
                <Col xs="12" sm="6" className="">
                  <FormGroupDisplay
                    label="Account Holder Name"
                    value={user?.fld_holdername}
                  />
                </Col>
                <Col xs="12" sm="6" className="">
                  <FormGroupDisplay
                    label="Bank Name"
                    value={user?.fld_bankname}
                  />
                </Col>
                <Col xs="12" sm="6" className="">
                  <FormGroupDisplay label="State" value={user?.fld_bankstate} />
                </Col>
                <Col xs="12" sm="6" className="">
                  <FormGroupDisplay label="City" value={user?.fld_bankcity} />
                </Col>
                <Col xs="12" sm="6" className="">
                  <FormGroupDisplay
                    label="Account Number"
                    value={user?.fld_accountno}
                  />
                </Col>
                <Col xs="12" sm="6" className="">
                  <FormGroupDisplay
                    label="IFSC Code"
                    value={user?.fld_ifsccode}
                  />
                </Col>
                <Col xs="12" sm="6" className="">
                  <FormGroupDisplay
                    label="UPI Id"
                    value={user?.fld_upi || "N/A"}
                  />
                </Col>
              </Row>
              <div className="d-flex justify-content-end">
                <button
                  style={{ textTransform: "capitalize" }}
                  onClick={() => setAddBankModal(true)}
                  className="btns"
                >
                  Edit Details
                </button>
              </div>
            </>
          )}
        </CardBody>
      </Card>
      {addBankModal && (
        <CommonModal
          isOpen={addBankModal}
          toggle={() => setAddBankModal(false)}
          heading={`${type} Bank Details`}
          modalSize={"lg"}
          contentBody={
            <Row>
              <Col sm="6">
                <FormGroup>
                  <Label htmlFor="nameVertical">
                    Account Holder Name<span className="mandatory">*</span>
                  </Label>
                  <Input
                    type="text"
                    name="AuditorName"
                    id="nameVertical"
                    disabled={!isEditable}
                    style={{ textTransform: "capitalize" }}
                    placeholder="Enter your Account Holder Name"
                    onChange={formik.handleChange}
                    value={formik.values.AuditorName}
                    invalid={
                      formik.touched.AuditorName && !!formik.errors.AuditorName
                    }
                  />
                  {formik.touched.AuditorName && formik.errors.AuditorName && (
                    <FormFeedback>{formik.errors.AuditorName}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
              <Col sm="6">
                <FormGroup>
                  <Label htmlFor="nameVertical">
                    Account Number<span className="mandatory">*</span>
                  </Label>
                  <Input
                    type="text"
                    disabled={!isEditable}
                    name="AccountNumber"
                    id="nameVertical"
                    placeholder="Enter your Account Number"
                    onChange={formik.handleChange}
                    value={formik.values.AccountNumber}
                    invalid={
                      formik.touched.AccountNumber &&
                      !!formik.errors.AccountNumber
                    }
                  />
                  {formik.touched.AccountNumber &&
                    formik.errors.AccountNumber && (
                      <FormFeedback>{formik.errors.AccountNumber}</FormFeedback>
                    )}
                </FormGroup>
              </Col>

              <Col sm="3">
                <FormGroup>
                  <Label htmlFor="nameVertical">
                    IFSC Code<span className="mandatory">*</span>
                  </Label>
                  <Input
                    type="text"
                    name="BankIfscCode"
                    id="nameVertical"
                    disabled={!isEditable}
                    //   style={{ textTransform: "uppercase" }}
                    placeholder="Enter your IFSC Code"
                    //   onChange={formik.handleChange}
                    onChange={(e) => {
                      // Convert input value to uppercase
                      const upperCaseValue = e.target.value?.toUpperCase();
                      formik.setFieldValue("BankIfscCode", upperCaseValue);
                    }}
                    value={formik.values.BankIfscCode}
                    invalid={
                      formik.touched.BankIfscCode &&
                      !!formik.errors.BankIfscCode
                    }
                  />
                  {formik.touched.BankIfscCode &&
                    formik.errors.BankIfscCode && (
                      <FormFeedback>{formik.errors.BankIfscCode}</FormFeedback>
                    )}
                </FormGroup>
              </Col>
              <Col sm="3" className="mt-md-4">
                <Button
                  className="btns "
                  style={{ textTransform: "capitalize" }}
                  onClick={findBankHandler}
                >
                  Find Bank
                </Button>
              </Col>
              <Col sm="6">
                <FormGroup>
                  <Label htmlFor="nameVertical">
                    Bank Name<span className="mandatory">*</span>
                  </Label>
                  <Input
                    type="text"
                    name="BankName"
                    id="nameVertical"
                    disabled={true}
                    style={{ textTransform: "capitalize" }}
                    placeholder="Enter your Branch Name"
                    onChange={formik.handleChange}
                    value={formik.values.BankName}
                    invalid={
                      formik.touched.BankName && !!formik.errors.BankName
                    }
                  />
                  {formik.touched.BankName && formik.errors.BankName && (
                    <FormFeedback>{formik.errors.BankName}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
              <Col sm="6" style={{ zIndex: "4" }}>
                <FormGroup>
                  <Label htmlFor="">
                    State<span className="mandatory">*</span>
                  </Label>
                  <Select
                    classNamePrefix="select"
                    name="AuditorState"
                    isDisabled={true}
                    onChange={(selectedOption) => {
                      formik.setFieldValue("AuditorState", selectedOption);
                      formik.setFieldValue("AuditorCity", "");
                    }}
                    value={formik.values.AuditorState}
                    options={allState}
                    className={`React ${
                      formik.touched.AuditorState && formik.errors.AuditorState
                        ? "is-invalid"
                        : ""
                    }`}
                    styles={generateCustomStyles("AuditorState", formik)}
                  />
                  {formik.touched.AuditorState &&
                    formik.errors.AuditorState && (
                      <FormFeedback>
                        {formik.errors.AuditorState.value}
                      </FormFeedback>
                    )}
                </FormGroup>
              </Col>

              <Col sm="6" style={{ zIndex: "3" }}>
                <FormGroup>
                  <Label htmlFor="">
                    City<span className="mandatory">*</span>
                  </Label>
                  <Select
                    classNamePrefix="select"
                    name="AuditorCity"
                    isDisabled={true}
                    onChange={(selectedOption) =>
                      formik.setFieldValue("AuditorCity", selectedOption)
                    }
                    options={allCity}
                    value={formik.values.AuditorCity}
                    className={`React ${
                      formik.touched.AuditorCity && formik.errors.AuditorCity
                        ? "is-invalid"
                        : ""
                    }`}
                    styles={generateCustomStyles("AuditorCity", formik)}
                  />
                  {formik.touched.AuditorCity && formik.errors.AuditorCity && (
                    <FormFeedback>
                      {formik.errors.AuditorCity.value}
                    </FormFeedback>
                  )}
                </FormGroup>
              </Col>
              <Col
                sm="12"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                <hr
                  style={{
                    flexGrow: 1,
                    border: "none",
                    borderTop: "1px solid #ccc",
                  }}
                />
                <div style={{ whiteSpace: "nowrap", fontWeight: "bold" }}>
                  OR
                </div>
                <hr
                  style={{
                    flexGrow: 1,
                    border: "none",
                    borderTop: "1px solid #ccc",
                  }}
                />
              </Col>

              <Col sm="6">
                <FormGroup>
                  <Label htmlFor="nameVertical">UPI Id</Label>
                  <Input
                    type="text"
                    name="UpiId"
                    id="nameVertical"
                    disabled={!isEditable}
                    placeholder="Enter UPI ID"
                    onChange={formik.handleChange}
                    value={formik.values.UpiId}
                    invalid={formik.touched.UpiId && !!formik.errors.UpiId}
                  />
                  {formik.touched.UpiId && formik.errors.UpiId && (
                    <FormFeedback>{formik.errors.UpiId}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
            </Row>
          }
          onConfirm={submitHandler}
          confirmText={"Submit"}
          cancelText={"Cancel"}
          onCancel={() => setAddBankModal(false)}
        />
      )}
    </div>
  );
};
export default BankDetails;
